import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pos",
  "use": "icon-soc-pos-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-pos\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M192 256h640v512H192V256zm96 96v320h448V352H288z\" />\r\n  <path d=\"M384 448h256v64H384v-64zm0 128h160v64H384v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pos.svg
// module id = 6pmN
// module chunks = 478